import axios from "axios";
import { FoundItemRequest } from "../models";

export const postFoundItemRequest = async (body: FoundItemRequest) => {
  const { status } = await axios.post(
    `${process.env.REACT_APP_API_URL}/lost-found/api/v1/device-register/items/found`, body);

  return status;
}
